var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("实名登记")]),_c('p',[_vm._v("这里是实名登记页面。")])])
}]

export { render, staticRenderFns }